<template>
  <div class="core">
    <div class="layui-fluid">
      <div>
        <div class="layui-form layui-card-header layuiadmin-card-header-auto">
          <div>
            <div class="layui-inline"><label class="layui-search-label">账号</label></div>
            <div class="layui-inline">
              <input
                class="layui-input"
                autocomplete="off"
                v-model="t_user.queryObject['ACCOUNT:2']"
                placeholder="请输入账号"
              />
            </div>
            <div class="layui-inline"><label class="layui-search-label">用户名</label></div>
            <div class="layui-inline">
              <input
                class="layui-input"
                autocomplete="off"
                v-model="t_user.queryObject['USERNAME:2']"
                placeholder="请输入用户名"
              />
            </div>
            <div class="layui-inline"><label class="layui-search-label">用户类型</label></div>
            <div class="layui-inline">
              <layui-select
                ref="select1"
                :enabled="true"
                table-name="DB_ROLE"
                text-field="ROLENAME"
                value-field="ROLEID"
                :show-null-option="true"
                :queryCondition="{}"
                :enable-search="true"
                :sort="['ROLEID:DESC']"
                v-model="t_user.queryObject['ROLE_IDS:2']"
              ></layui-select>
            </div>
            <div class="layui-inline"><label class="layui-search-label">状态</label></div>
            <div class="layui-inline">
              <layui-select ref="select1" :enable-search="true" v-model="t_user.queryObject.STATE">
                <option value="">请选择一个</option>
                <option value="1">启用</option>
                <option value="0">注销</option>
              </layui-select>
            </div>
            <div class="layui-inline">
              <button class="layui-btn layuiadmin-btn-list" @click="$refs.t_user.search()" title="查询">查询</button>
              <button
                class="layui-btn"
                @click="
                  $refs.t_user.reset()
                  $refs.daterange.reset()
                "
                title="重置"
              >
                重置
              </button>
            </div>
          </div>
        </div>
        <div class="layui-card-body">
          <div class="ywpt-btn">
            <button
              class="layui-btn layuiadmin-btn-role"
              :class="{ 'layui-btn-disabled': t_user.checkedRows.length < 1 }"
              @click="$refs.t_user.delCheckedRows()"
            >
              删除
            </button>
            <button class="layui-btn layuiadmin-btn-role" @click="add()">添加</button>
          </div>
          <div class="layui-table-body layui-table-main">
            <layui-table
              ref="t_user"
              table-name="DB_USER"
              :sort="['UPDATE_TIME:DESC', 'ACCOUNT,USERNAME:ASC']"
              :page-size="15"
              :page-range="6"
              :page-options="[15, 25, 50, 100]"
              @rowClick="handleRowClick($event.data)"
              @table-event-editPassword="handleEditPassword($event)"
              @table-event-edit="edit($event)"
              @table-event-del="$refs.t_user.delRows($event.data)"
              @table-event-toEngineer="toEngineer($event)"
              @table-event-toManager="toManager($event)"
              height="full-270"
            >
              <div>
                <!-- 开启复选框 -->
                <div checkbox="true"></div>
                <div field="ACCOUNT" title="账号"></div>
                <div field="USERNAME" title="用户名"></div>
                <div field="TEL" title="手机号"></div>
                <div field="ROLE_IDS_DESC" title="用户类型"></div>
                <div field="STATE" title="状态" translateDomain="TRANSLATE_USER_STATE">
                  <script type="text/html" id="switchTpl" v-pre>
                    <input type="checkbox" name="state" value="{{d.STATE}}" data-userid="{{ d.USERID }}" lay-skin="switch" lay-text="启用|注销" lay-filter="sexDemo" {{ d.STATE === '1' ? 'checked' : '' }}>
                  </script>
                </div>
                <div field="UPDATE_TIME" title="更新时间"></div>
                <div align="center" toolbar title="操作" width="300">
                  <script type="text/html" v-pre>
                    <a class="layui-btn-xs" lay-event="edit">编辑</a>
                    {{#  if(d.ROLE_IDS == "10"){ }}
                    <a class="layui-btn-xs" lay-event="toEngineer">成为工程师</a>
                    {{#  } }}
                    {{#  if(d.ROLE_IDS == "9"){ }}
                    <a class="layui-btn-xs" lay-event="toManager">成为项目经理</a>
                    {{#  } }}
                    <a class="layui-btn-xs" lay-event="editPassword">修改密码</a>
                    <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del">删除</a>
                  </script>
                </div>
              </div>
            </layui-table>
          </div>
        </div>
      </div>
    </div>

    <layui-form ref="userForm" :rule="user_form_rule">
      <template slot-scope="{ scope }">
        <div class="layui-form" style="padding: 20px 30px 0 0;">
          <div class="layui-form-item">
            <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>用户类型（角色）：</label>
            <div class="layui-input-inline" style="width:480px">
              <layui-radio
                ref="roleRef"
                v-model="scope.editRow.ROLE_IDS"
                @selectChange="handleRoleselectChange($event)"
                table-name="DB_ROLE"
                text-field="ROLENAME"
                value-field="ROLEID"
                :selectFirst="true"
                :queryCondition="{}"
                :sort="['ROLEID:DESC']"
              >
              </layui-radio>
            </div>
          </div>
          <div class="layui-form-item" v-show="selectRole.ROLECODE == 'dz'">
            <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>请选择店长：</label>
            <div class="layui-input-inline">
              <layui-multiselect
                :enabled="true"
                :single="true"
                @selectChange="enginerChange($event)"
                table-name="YW_STORE_MANAGER"
                text-field="STORE_MANAGER_NAME"
                value-field="STORE_MANAGER_ID"
                :show-null-option="true"
                :queryCondition="{}"
                :enable-search="true"
                v-model="scope.editRow.F_ID"
              ></layui-multiselect>
            </div>
          </div>
          <div class="layui-form-item" v-show="selectRole.ROLECODE == 'gcs'">
            <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>请选择工程师：</label>
            <div class="layui-input-inline">
              <layui-multiselect
                :enabled="true"
                :single="true"
                @selectChange="enginerChange($event)"
                :renderText="renderEngineerText"
                table-name="YW_ENGINEER"
                text-field="ENGINEER_NAME"
                value-field="ENGINEER_ID"
                :show-null-option="true"
                :queryCondition="{}"
                :enable-search="true"
                v-model="scope.editRow.F_ID"
              ></layui-multiselect>
            </div>
          </div>
          <div class="layui-form-item" v-show="selectRole.ROLECODE == 'xmjl'">
            <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>请选择项目经理：</label>
            <div class="layui-input-inline">
              <layui-multiselect
                :enabled="true"
                :single="true"
                @selectChange="managerChange($event)"
                table-name="YW_MANAGER"
                text-field="MANAGER_NAME"
                value-field="MANAGER_ID"
                :show-null-option="true"
                :queryCondition="{}"
                :enable-search="true"
                v-model="scope.editRow.F_ID"
              ></layui-multiselect>
            </div>
          </div>
          <div class="layui-form-item" v-show="selectRole.ROLECODE == 'kh'">
            <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>请选择客户：</label>
            <div class="layui-input-inline">
              <!-- <layui-select
                :enabled="true"
                @selectChange="clientChange($event.data)"
                table-name="YW_CUSTOMER_CLIENT"
                text-field="CLIENT_NAME"
                value-field="CLIENT_ID"
                :show-null-option="true"
                :queryCondition="{}"
                :enable-search="true"
                v-model="scope.editRow.F_ID"
              ></layui-select> -->
               <layui-tableselect
                      table-name="YW_CUSTOMER_CLIENT"
                      @selectChange="clientChange($event)"
                      input-width="100%"
                      table-width="800px"
                      text-width="100%"
                      text-field="CLIENT_NAME"
                      value-field="CLIENT_ID"
                      queryFields="CLIENT_BH,CLIENT_NAME,PERSON_NAME"
                      v-model="scope.editRow.F_ID"
                      tip="请选择客户"
                      :sort="['CLIENT_NAME  :DESC']"
                      :page-size="50"
                      :page-range="6"
                      :page-options="[15, 25, 50, 100]"
                      style="width:400px"
                    >
                      <div>
                          <div radio="true"></div>
                          <div field="CLIENT_BH" title="客户编码" width="120"></div>
                          <div field="CLIENT_NAME" title="客户名称" width="280"></div>
                          <div field="PERSON_PHONE" title="联系人姓名" width="120"></div>
                          <div field="PERSON_PHONE" title="联系人电话" width="120"></div>
                          <div field="PROVINCE_DESC" title="省" ></div>
                          <div field="CITY_DESC" title="市" ></div>
                          <div field="DISTRICT_DESC" title="县" ></div>
                          <div field="ADDRESS" title="地址" ></div>
                      </div>
                    </layui-tableselect>
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>账号（登录用）：</label>
            <div class="layui-input-inline">
              <input
                type="text"
                v-model="scope.editRow.ACCOUNT"
                autocomplete="off"
                class="layui-input"
                name="ACCOUNT"
                placeholder="请输入账号"
              />
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>手机号（登录用）：</label>
            <div class="layui-input-inline">
              <input
                type="text"
                v-model="scope.editRow.TEL"
                autocomplete="off"
                class="layui-input"
                name="TEL"
                placeholder="请输入手机号"
              />
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>用户名：</label>
            <div class="layui-input-inline">
              <input
                type="text"
                v-model="scope.editRow.USERNAME"
                autocomplete="off"
                class="layui-input"
                name="USERNAME"
                placeholder="请输入用户名"
              />
            </div>
          </div>
          <div class="layui-form-item" v-if="scope.isInsert()">
            <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>密码：</label>
            <div class="layui-input-inline">
              <input
                type="password"
                v-model="scope.editRow.PASSWORD"
                autocomplete="off"
                class="layui-input"
                name="PASSWORD"
                placeholder="请输入密码"
              />
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label" style="width:150px">状态：</label>
            <div class="layui-input-inline" style="width:480px">
              <layui-radio v-model="scope.editRow.STATE" name="STATE">
                <input type="radio" value="1" title="启用" />
                <input type="radio" value="0" title="注销" />
              </layui-radio>
            </div>
          </div>

          <div class="layui-form-item">
            <label for="L_repass" class="layui-form-label"> </label>
            <button class="layui-btn" @click="save()">保存</button>
            <button class="layui-btn" @click="$refs.userForm.close()">关闭</button>
          </div>
        </div>
      </template>
    </layui-form>

    <layui-form ref="updatePasswordForm" style="display: none">
      <template slot-scope="{ scope }">
        <div class="layui-form" style="padding: 20px 30px 0 0;">
          <div class="layui-form-item">
            <label class="layui-form-label"><span class="x-red">*</span>新密码：</label>
            <div class="layui-input-inline">
              <input
                type="password"
                name="password"
                autocomplete="off"
                class="layui-input"
                v-model="scope.editRow.newPw"
              />
            </div>
            <div class="layui-form-mid layui-word-aux">6到16个字符</div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label"><span class="x-red">*</span>确认新密码：</label>
            <div class="layui-input-inline">
              <input
                type="password"
                name="repassword"
                autocomplete="off"
                class="layui-input"
                v-model="scope.editRow.repeat"
              />
            </div>
          </div>
          <div class="layui-form-item">
            <div class="layui-input-block" style="margin-left:140px">
              <button class="layui-btn" @click="changePw()">确认修改</button>
            </div>
          </div>
        </div>
      </template>
    </layui-form>
      <layui-form ref="toEngineerForm">
        <template slot-scope="{ scope }">
          <div class="layui-form" style="padding: 20px 30px 0 0;">
            <div class="layui-form-item">
              <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>请选择工程师：</label>
              <div class="layui-input-inline" style="width:250px">
                <layui-multiselect
                  :enabled="true"
                  :single="true"
                  :renderText="renderEngineerText"
                  table-name="YW_ENGINEER"
                  text-field="ENGINEER_NAME"
                  value-field="ENGINEER_ID"
                  :show-null-option="true"
                  :queryCondition="{}"
                  :enable-search="true"
                  v-model="scope.editRow.engineerId"
                ></layui-multiselect>
              </div>
            </div>
            <div class="layui-form-item" style="margin-top:100px">
              <label for="L_repass" class="layui-form-label"> </label>
              <button class="layui-btn" @click="doToEngineer()">确定</button>
              <button class="layui-btn" @click="$refs.toEngineerForm.close()">关闭</button>
            </div>
          </div>
        </template>
      </layui-form>
       <layui-form ref="toManagerForm">
        <template slot-scope="{ scope }">
          <div class="layui-form" style="padding: 20px 30px 0 0;">
            <div class="layui-form-item">
              <label class="layui-form-label" style="width:150px"> <span class="x-red">*</span>请选择项目经理：</label>
              <div class="layui-input-inline" style="width:250px">
                <layui-multiselect
                  :enabled="true"
                  :single="true"
                  table-name="YW_MANAGER"
                  text-field="MANAGER_NAME"
                  value-field="MANAGER_ID"
                  :show-null-option="true"
                  :queryCondition="{}"
                  :enable-search="true"
                  v-model="scope.editRow.managerId"
                ></layui-multiselect>
              </div>
            </div>
            <div class="layui-form-item" style="margin-top:100px">
              <label for="L_repass" class="layui-form-label"> </label>
              <button class="layui-btn" @click="doToManager()">确定</button>
              <button class="layui-btn" @click="$refs.toManagerForm.close()">关闭</button>
            </div>
          </div>
        </template>
      </layui-form>
  </div>
</template>

<script>
import request from '../../../network/networkconfig'
export default {
  name: 'User',
  data() {
    return {
      t_user: {
        checkedRows: 0,
        queryObject: {}
      },
      user_form_rule: {
        ACCOUNT: {
          required: { message: '登录名不能为空' }
        },
        USERNAME: {
          required: { message: '用户名不能为空' }
        },
        TEL: {
          required: { message: '电话不能为空' },
          phone: { message: '请填写正确的手机号格式'}
        },
        PASSWORD: {
          optional: false,
          required: { message: '密码不能为空' }
        }
      },
      selectRole: {}
    }
  },
  mounted() {
    this.t_user = this.$refs.t_user
    this.userForm = this.$refs.userForm
    this.updatePasswordForm = this.$refs.updatePasswordForm;
    this.layui.form.on('switch(sexDemo)', (obj) => {
        let title = obj.elem.checked ? '启用' : '注销';
        this.layer.openConfirm('确定要' + title + "该用户吗？", ()=> {
            let editRow = {IS_NEW: false};
            editRow['USERID'] = obj.elem.dataset.userid;
            editRow.STATE = obj.elem.checked ? '1' : '0';
            this.api.save('DB_USER', editRow,  'OnOffUser').then(response => {
                if(response.errorMsg) {
                    this.layer.openAlert(response.errorMsg, false);
                } else {
                    this.layer.openSuccess(title + '成功!');
                    this.t_user.pageInfo.pageIndex = 1;
                    this.t_user.load();
                }
            });
        }, () => {this.t_user.load();});
      });
  },
  methods: {
    toEngineer($event){
      this.curRow = $event.data;
      this.$refs.toEngineerForm.open('成为工程师')
    },
    toManager($event){
      this.curRow = $event.data;
      this.$refs.toManagerForm.open('成为项目经理')
    },
    doToManager(){
        if(!this.curRow) return;
        let managerForm = this.$refs.toManagerForm;
        if(!managerForm.editRow.managerId){
          this.layer.openAlert('请选择项目经理！', false);
          return;
        }
        let editRow = {IS_NEW: false};
        editRow['USERID'] = this.curRow.USERID;
        editRow['ROLE_IDS'] = '9,10'
        editRow['F_MANAGER_ID'] = managerForm.editRow.managerId
        this.api.save('DB_USER', editRow,  'doToManager').then(response => {
            if(response.errorMsg) {
                this.layer.openAlert(response.errorMsg, false);
            } else {
                this.layer.openSuccess('操作成功!');
                managerForm.close();
                this.t_user.pageInfo.pageIndex = 1;
                this.t_user.load();
            }
        });
    },
    doToEngineer(){
        if(!this.curRow) return;
        let toEngineerForm = this.$refs.toEngineerForm;
        if(!toEngineerForm.editRow.engineerId){
          this.layer.openAlert('请选择工程师！', false);
          return;
        }
        let editRow = {IS_NEW: false};
        editRow['USERID'] = this.curRow.USERID;
        editRow['ROLE_IDS'] = '9,10'
        editRow['F_ENGINEER_ID'] = toEngineerForm.editRow.engineerId
        this.api.save('DB_USER', editRow,  'doToEngineer').then(response => {
            if(response.errorMsg) {
                this.layer.openAlert(response.errorMsg, false);
            } else {
                this.layer.openSuccess('操作成功!');
                toEngineerForm.close();
                this.t_user.pageInfo.pageIndex = 1;
                this.t_user.load();
            }
        });
    },
    add() {
      this.$refs.userForm.openWin('新增用户')
      this.selectRole = {}
      this.user_form_rule.PASSWORD.optional = false
      this.$refs.userForm.setEditRow({ STATE: 1 })
    },
    edit($event) {
      this.$refs.userForm.openWin('编辑用户')
      this.user_form_rule.PASSWORD.optional = true
      let editRow = $event.data
      editRow.PASSWORD = null //编辑的时候不修改密码，密码单独修改
      this.$refs.userForm.setEditRow(editRow)
      var roleDatas = this.$refs.roleRef.getData();
      for(var i  = 0 ; i < roleDatas.length; i++) {
        var role = roleDatas[i];
        if(role.ROLEID == editRow.ROLE_IDS){
          this.handleRoleselectChange(role);
          break;
        }
      }
    },
    exportExcel() {
      var exportObj = this.$refs.export
      exportObj.setTemplateName('用户信息表.xls')
      exportObj.export(this.$refs.t_user)
    },
    handleRowClick(row) {
      this.t_user.setCheckRow(row)
    },
    managerChange(managerRow) {
      if(!managerRow[0]) return;
      managerRow = managerRow[0]._row;
      this.$set(this.$refs.userForm.editRow, 'TEL', managerRow.MANAGER_PHONE)
      this.$set(this.$refs.userForm.editRow, 'USERNAME', managerRow.MANAGER_NAME)
    },
    enginerChange(enginerRow) {
      if(!enginerRow[0]) return;
      enginerRow = enginerRow[0]._row;
      this.$set(this.$refs.userForm.editRow, 'TEL', enginerRow.ENGINEER_PHONE)
      this.$set(this.$refs.userForm.editRow, 'USERNAME', enginerRow.ENGINEER_NAME)
    },
    clientChange(clientRow) {
      if(!clientRow[0]) return;
      clientRow = clientRow[0];
      this.$set(this.$refs.userForm.editRow, 'TEL', clientRow.PERSON_PHONE)
      this.$set(this.$refs.userForm.editRow, 'USERNAME', clientRow.CLIENT_NAME)
    },
    handleRoleselectChange(roleRow) {
      this.selectRole = roleRow
    },
    handleEditPassword(row) {
      this.updatePasswordForm.setEditRow(row.data)
      this.updatePasswordForm.open('修改密码')
    },
    changePw() {
      let editRow = this.updatePasswordForm.editRow
      let newPw = editRow.newPw
      let repeat = editRow.repeat
      if (!newPw) {
        this.layer.openAlert('请输入新密码！', false)
        return
      }
      if (!repeat) {
        this.layer.openAlert('请输入确认新密码！', false)
        return
      }
      if (newPw != repeat) {
        this.layer.openAlert('新密码两次输入不一致！', false)
        return
      }
      var base64 = new Base64()
      var newPassword = base64.encode(unescape(encodeURIComponent(newPw)))
      request({
        url: '/login/updatepw/' + editRow.USERID + '/' + newPassword,
        method: 'post'
      }).then(response => {
        if (response.errorMsg) {
          this.layer.openAlert(response.errorMsg, false)
        } else {
          if (response.result == true) {
            this.layer.openSuccess('修改成功!')
            layer.closeAll()
          } else {
            this.layer.openAlert(response.result, false)
          }
        }
      })
    },
    save(){
        this.userForm.saveCallback(this.t_user, {
            error: (response) =>{
                var errorMsg = response.errorMsg;
                if(errorMsg.indexOf('TEL_UNIQUE') > 0) {
                      this.layer.openAlert('手机号已经存在！', false);
                } else {
                    this.layer.openAlert(errorMsg, false);
                }
            }
        })
    },
    renderEngineerText(row){
        var  content = row['ENGINEER_NAME'] + '【' + row['SERVICE_ID_DESC'] + '】'
        return content;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ywpt/user/User.vue